import { Fragment, ReactElement } from 'react';
import Breadcrumbs, { BreadcrumbItem } from 'shell/components/shared/breadcrumb';
import PersonSearch from 'shell/components/shared/person-search';
import ActionsList from './actions';

interface ResearchMarriageNotificationsSharedProps {
  goBackUrl?: string;
  redirectUrl?: string;
  items?: BreadcrumbItem[];
}

const ResearchMarriageNotificationsShared = ({
  goBackUrl,
  redirectUrl,
  items = [],
}: ResearchMarriageNotificationsSharedProps): ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={items} />
      <PersonSearch
        pathname={redirectUrl}
        action={ActionsList}
        addedTitle="- Registrazione Matrimonio"
        goBackUrl={goBackUrl}
      />
    </Fragment>
  );
};

ResearchMarriageNotificationsShared.displayName =
  'Research Marriage Notifications Shared component';

export default ResearchMarriageNotificationsShared;
